import { querySelectorAllShadows } from "../utility";

export class PlatformService {
  isAndroidEnvironment(): boolean {
    const isAndroidObject = !!(window as any).Android;
    const isAndroidWebView = this.isAndroidWebView(navigator?.userAgent || '');

    return isAndroidObject && isAndroidWebView;
  }

  isIosEnvironment(): boolean {
    const isIosObject = !!(window as any).webkit?.messageHandlers;
    const isIosWebView = this.isIosWebView(navigator?.userAgent || '');

    return isIosObject && isIosWebView;
  }

  isMobileAppEnvironment(): boolean {
    const isAndroidEnvironment = this.isAndroidEnvironment();
    const isIosEnvironment = this.isIosEnvironment()

    return isAndroidEnvironment || isIosEnvironment;
  }

  pnlUserMenuExists(): boolean {
    return querySelectorAllShadows('pnl-user-menu').length > 0;
  }

  private isAndroidWebView(userAgent: string): boolean {
    return userAgent && /Android.*(wv|WebView).*PostNL/i.test(userAgent);
  }

  private isIosWebView(userAgent: string): boolean {
    return userAgent && /AppleWebKit.*PostNL/i.test(userAgent);
  }
}
